import React from 'react';
import {
  FormInput,
  FormItemContainer,
  FormRadioItem,
  FormLabel,
} from '../components/FormInput';

const SignUpContent = ({
  handleChange,
  formData,
  currentTitle,
  currentInputs,
  currentStep,
  errorData,
  filteredSchoolList,
  schoolListVisible,
  filtering,
  selectSchoolFromList,
  onFormClick,
  currentForm,
}) => {
  const steps = 6;

  return (
    <>
      <div className='relative w-52'>
        <div className='absolute top-1/2 transform -translate-y-px inset-y-0 left-0 w-full h-0.5 bg-coolGray-200 z-10'></div>
        <div className='relative flex justify-between py-8 z-20'>
          {Array.from({ length: steps }).map((_, index) => (
            <div
              key={index}
              className={`${
                currentStep === index ? 'bg-dms-primary' : 'bg-coolGray-200'
              } h-4 w-4 rounded-full`}
            ></div>
          ))}
        </div>
      </div>
      {currentTitle && (
        <h3 className='pl-0 pt-0 text-semibold text-2xl'>{currentTitle}</h3>
      )}
      {currentStep !== 2 && currentStep !== 3 && currentStep !== 5 && (
        <div className='leading-4 mt-2'>
          <span className='text-red-600'>*</span>
          <span className='font-semibold text-small'> indicates required</span>
        </div>
      )}
      {currentForm && currentForm['successText'] && (
        <div
          className='w-2/3 ml-0'
          dangerouslySetInnerHTML={{
            __html: currentForm['successText']([formData['email']]),
          }}
        />
      )}
      {currentInputs && (
        <form>
          {currentInputs.map((input, index) => (
            <div key={input.name}>
              {input.type !== `radio` && input.type !== 'multiButton' && (
                <div className='col-span-1 flex flex-col flex-1 mt-8'>
                  <FormInput
                    labelText={input.label}
                    type={input.type}
                    placeHolderText=''
                    value={formData[input.name] || ''}
                    errorMessage={errorData[input.name]}
                    hint={input.hint}
                    name={input.name}
                    onChange={handleChange}
                    required={
                      currentStep !== 2 && currentStep !== 3 && input.required
                    }
                    filteredSchoolList={filteredSchoolList}
                    schoolListVisible={schoolListVisible}
                    filtering={filtering}
                    selectSchoolFromList={selectSchoolFromList}
                  />
                </div>
              )}
              {input.type === 'radio' && (
                <div
                  key={input.name}
                  className='col-span-1 flex flex-col flex-1 mt-8'
                >
                  <FormItemContainer
                    labelText={input.label}
                    hint={input.hint}
                    required={input.required}
                  >
                    <FormRadioItem
                      type={input.type}
                      placeholder=''
                      value={true}
                      checked={
                        formData[input.name] === true ||
                        formData['is_faculty'] === true
                      }
                      name={input.name}
                      onChange={handleChange}
                      spanText={`${
                        input.name === 'universityRole' ? 'Instructor' : 'Yes'
                      }`}
                    />
                    <FormRadioItem
                      type={input.type}
                      placeholder=''
                      value={false}
                      checked={
                        formData[input.name] === false ||
                        formData['is_faculty'] === false
                      }
                      name={input.name}
                      onChange={handleChange}
                      spanText={`${
                        input.name === 'universityRole' ? 'Staff' : 'No'
                      }`}
                    />
                  </FormItemContainer>
                </div>
              )}
              {input.type === 'multiButton' && (
                <div className='col-span-1 flex flex-col flex-1 leading-4 text-semibold'>
                  <FormLabel labelText={input.label} name={input.name} />
                  <div className='mt-5 flex flex-wrap'>
                    {input.radialButtonCopy.map((button, index) => (
                      <button
                        key={index}
                        className={`mr-2 my-2 py-2 px-4  text-base font-medium cursor-pointer transition duration-100 rounded z-10 h-auto  ${
                          formData['industry'] === button.text
                            ? 'py-2 px-5 border-2 border-dms-primary text-white bg-dms-primary hover:text-dms-primary hover:bg-white'
                            : 'text-dms-primary border-2 border-dms-primary hover:bg-dms-primary hover:text-white'
                        }`}
                        value={button.text}
                        onClick={onFormClick}
                        type={button.type}
                      >
                        {button.text}
                      </button>
                    ))}
                  </div>
                  {formData['industry'] === 'Other' && (
                    <div className='col-span-1 flex flex-col flex-1 mt-8 ml-0'>
                      <FormInput
                        labelText={
                          'Tell us what area your employer is active in'
                        }
                        type='text'
                        placeHolderText=''
                        value={formData['otherIndustry'] || ''}
                        errorMessage={errorData['otherIndustry']}
                        hint={input.hint}
                        name={'otherIndustry'}
                        onChange={handleChange}
                        required={input.required}
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          ))}
        </form>
      )}
    </>
  );
};

export default SignUpContent;
